module.exports = __webpack_public_path__ + "img/telegrmhover.c4036de1.svg";